export default {
  path: '/crm',
  component: () => import('@/views/crm/Index'),
  children: [
    {
      path: 'follow-up-automation',
      component: () => import('@/views/crm/follow-up-automation/Index'),
      children: [
        {
          path: '',
          name: 'crm-follow-up-automation',
          component: () => import('@/views/crm/follow-up-automation/List'),
          meta: {
            title: 'Follow-up Automation',
            roles: ['general_manager', 'sales_supervisor', 'marketing_supervisor']
          }
        },
        {
          path: ':run_id',
          name: 'crm-follow-up-automation-detail',
          component: () => import('@/views/crm/follow-up-automation/Detail'),
          meta: {
            title: 'Follow-up Automation',
            roles: ['general_manager', 'sales_supervisor', 'marketing_supervisor']
          }
        }
      ]
    },
    {
      path: 'task-tracker',
      component: () => import('@/views/crm/task-tracker/Layout'),
      children: [
        {
          path: '',
          name: 'crm-task-tracker',
          component: () => import('@/views/crm/task-tracker/Index'),
          meta: {
            title: 'Lead Flow · Task Tracker',
            roles: ['general_manager', 'marketing_supervisor', 'sales_supervisor', 'lead_new_flow']
          }
        },
        {
          path: 'leads',
          name: 'crm-task-tracker-leads',
          component: () => import('@/views/crm/task-tracker/LeadsList'),
          meta: {
            title: 'Lead Flow · Leads',
            roles: ['general_manager', 'marketing_supervisor', 'sales_supervisor', 'lead_new_flow']
          }
        },
        {
          path: 'double-requests',
          name: 'crm-task-tracker-double-requests',
          component: () => import('@/views/crm/task-tracker/DoubleRequests'),
          meta: {
            title: 'Lead Flow · Double Requests',
            roles: ['general_manager', 'marketing_supervisor', 'sales_supervisor', 'lead_new_flow']
          }
        }
      ]
    },
    {
      path: 'trengo',
      component: () => import('@/views/crm/trengo-workspace/Layout'),
      redirect: { name: 'crm-trengo-matching' },
      children: [
        {
          path: 'matching',
          name: 'crm-trengo-matching',
          component: () => import('@/views/crm/leads/communication-reconciliation/Index'),
          props: { flowVersion: 'v2' },
          meta: {
            title: 'Trengo · Matching',
            roles: ['general_manager', 'marketing_supervisor']
          }
        },
        {
          path: 'matching-legacy',
          name: 'crm-trengo-matching-legacy',
          component: () => import('@/views/crm/leads/communication-reconciliation/Index'),
          props: { flowVersion: 'legacy' },
          meta: {
            title: 'Trengo · Matching Legacy',
            roles: ['general_manager', 'marketing_supervisor']
          }
        },
        {
          path: 'tickets',
          name: 'trengo-tickets',
          component: () => import('@/views/crm/trengo-workspace/Tickets'),
          meta: {
            title: 'Trengo · Tickets',
            roles: ['general_manager']
          }
        },
        {
          path: 'tickets/:id',
          name: 'trengo-tickets-detail',
          component: () => import('@/views/crm/trengo/Detail'),
          meta: {
            title: 'Trengo · Ticket',
            roles: ['general_manager']
          }
        },
        {
          path: 'wa-webhooks',
          name: 'whatsApp-webhooks',
          component: () => import('@/views/crm/trengo-workspace/WAWebhooks'),
          meta: {
            title: 'Trengo · WA Webhooks',
            roles: ['general_manager']
          }
        },
        {
          path: 'resources/:resource?',
          redirect: to => ({
            name: 'tech-support-trengo',
            params: { resource: to.params.resource || 'channels' },
            query: to.query,
            hash: to.hash
          }),
          meta: {
            title: 'Trengo resources',
            roles: ['general_manager', 'marketing_supervisor']
          }
        }
      ]
    },
    {
      path: 'communication-reconciliation',
      redirect: to => {
        const query = { ...to.query }
        const name = query.flow === 'legacy' ? 'crm-trengo-matching-legacy' : 'crm-trengo-matching'
        delete query.flow
        return { name, query, hash: to.hash }
      }
    },
    {
      path: 'leads',
      component: () => import('@/views/crm/leads/Index'),
      children: [
        {
          path: '',
          name: 'leads-list',
          component: () => import('@/views/crm/leads/List'),
          meta: {
            title: 'Leads',
            roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'marketing_supervisor', 'support']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/crm/leads/detail/Index'),
          children: [
            {
              path: '',
              component: () => import('@/views/crm/leads/detail/Layout'),
              children: [
                {
                  path: '',
                  name: 'leads-detail-lead',
                  component: () => import('@/views/crm/leads/detail/Lead'),
                  meta: {
                    roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'marketing_supervisor', 'support']
                  }
                },
                {
                  path: 'invoices',
                  name: 'leads-detail-invoices',
                  component: () => import('@/views/crm/leads/detail/Invoices'),
                  meta: {
                    roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'support']
                  }
                },
                {
                  path: 'reservations',
                  name: 'leads-detail-reservations',
                  component: () => import('@/views/crm/leads/detail/Reservations'),
                  meta: {
                    roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'support']
                  }
                },
                {
                  path: 'status',
                  name: 'leads-detail-status',
                  component: () => import('@/views/crm/leads/detail/Status'),
                  meta: {
                    roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'marketing_supervisor', 'support']
                  }
                },
                {
                  path: 'messages',
                  name: 'leads-detail-messages',
                  component: () => import('@/views/crm/leads/detail/Messages'),
                  meta: {
                    roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'marketing_supervisor', 'support']
                  }
                },
                {
                  path: 'advertising',
                  name: 'leads-detail-advertising',
                  component: () => import('@/views/crm/leads/detail/Advertising'),
                  meta: {
                    roles: []
                  }
                },
              ]
            }
          ],
        },
      ]
    },
    {
      path: 'trengo-tickets',
      redirect: { name: 'trengo-tickets' }
    },
    {
      path: 'trengo-tickets/whatsApp-webhooks',
      redirect: { name: 'whatsApp-webhooks' }
    },
    {
      path: 'trengo-tickets/:id',
      redirect: to => ({ name: 'trengo-tickets-detail', params: { id: to.params.id } })
    },
    {
      path: 'allowance',
      component: () => import('@/views/crm/allowance/Index'),
      children: [
        {
          path: '',
          name: 'allowance-list',
          component: () => import('@/views/crm/allowance/List'),
          meta: {
            title: 'Allowances',
            roles: ['general_manager']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/crm/allowance/detail/Layout'),
          children: [
            {
              path: '',
              name: 'allowance-employee',
              component: () => import('@/views/crm/allowance/detail/Employee'),
              meta: {
                title: 'Allowance employee',
                roles: ['general_manager']
              }
            },
            {
              path: 'log',
              name: 'allowance-log',
              component: () => import('@/views/crm/allowance/detail/Log'),
              meta: {
                title: 'Allowance log',
                roles: ['general_manager']
              }
            },
          ],
        },
      ]
    },
    {
      path: 'analytics',
      component: () => import('@/views/crm/analytics/Layout'),
      children: [
        {
          path: '',
          name: 'crm-analytics-requests',
          component: () => import('@/views/crm/analytics/Requests'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'managers',
          name: 'crm-analytics-managers-requests',
          component: () => import('@/views/crm/analytics/ManagersRequests'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'performance',
          name: 'crm-analytics-performance-requests',
          component: () => import('@/views/crm/analytics/PerformanceRequests'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'sales',
          name: 'crm-analytics-sales',
          component: () => import('@/views/crm/analytics/Sales'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'sales/managers',
          name: 'crm-analytics-managers-sales',
          component: () => import('@/views/crm/analytics/ManagersSales'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'advertising',
          name: 'crm-analytics-advertising',
          component: () => import('@/views/crm/analytics/Advertising'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'urls',
          name: 'crm-analytics-urls',
          component: () => import('@/views/crm/analytics/URLs'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'regions',
          name: 'crm-analytics-regions',
          component: () => import('@/views/crm/analytics/Regions'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'sales/regions',
          name: 'crm-analytics-regions-sales',
          component: () => import('@/views/crm/analytics/RegionsSales'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'sales/urls',
          name: 'crm-analytics-urls-sales',
          component: () => import('@/views/crm/analytics/URLsSales'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'clients-profile',
          name: 'crm-analytics-clients-profile',
          component: () => import('@/views/crm/analytics/ClientsProfile'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'expenses',
          name: 'crm-analytics-expenses',
          component: () => import('@/views/crm/analytics/Expenses'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_assistant', 'marketing_supervisor']
          }
        },
        {
          path: 'marketing-dashboard',
          name: 'crm-analytics-marketing-dashboard',
          component: () => import('@/views/crm/analytics/MarketingDashboard'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_supervisor']
          }
        },
        {
          path: 'cohorts',
          name: 'crm-analytics-cohorts',
          component: () => import('@/views/crm/analytics/Cohorts'),
          meta: {
            title: 'CRM Analytics — Cohorts',
            roles: ['general_manager', 'marketing_supervisor']
          }
        },
        {
          path: 'dashboard-builder',
          name: 'crm-analytics-dashboard-builder',
          component: () => import('@/views/crm/analytics/DashboardBuilder'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager', 'marketing_supervisor']
          }
        },
        {
          path: 'conversions',
          name: 'crm-analytics-conversions',
          component: () => import('@/views/crm/analytics/Conversions'),
          meta: {
            title: 'CRM Analytics — Conversions',
            roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant']
          }
        },
        {
          path: 'api',
          name: 'crm-analytics-api',
          component: () => import('@/views/crm/analytics/API'),
          meta: {
            title: 'CRM Analytics',
            roles: ['general_manager']
          }
        },
        // {
        //   path: 'tour-dates',
        //   name: 'crm-analytics-tour-dates',
        //   component: () => import('@/views/crm/analytics/TourDates'),
        //   meta: {
        //     title: 'CRM Analytics',
        //     roles: ['general_manager', 'sales_manager']
        //   }
        // },
      ],
    },
  ]
}
